import { computed } from 'vue';
import { groupBy } from 'utils';

import {
  fetchDataSources,
  getDataSource,
  createDataSource,
  updateDataSource,
  STATUS,
} from 'api/dataSources';

import { Resource, computedMapById } from './store';

export default Resource.build(({ state }) => {
  const avail = computed(() => state.data?.filter(ds =>
    ds.status !== STATUS.OFF && ds.status !== STATUS.DRAFT,
  ) || []);
  const byAppId = computed(() => groupBy(state.data, 'appId'));

  return {
    name: 'DataSources',
    state,

    values: {
      byId: computedMapById(state),
      avail,
      noExternal: computed(() => avail.value.filter(ds => ds.group !== 'external' )),
      defaultForApp: computed(() => avail.value.find(ds => ds.defaultSource) || avail.value[0]),

      byAppId,
      dfltByAppId: computed(() => {
        const dfltByAppId = {};
        Object.keys(byAppId.value).forEach(appId => {
          const dss = byAppId.value[appId];
          const dflt = dss.find(ds => ds.defaultSource) || dss[0];
          dfltByAppId[appId] = dflt;
        });
        return dfltByAppId;
      }),
    },

    actReqs: {
      fetch: fetchDataSources,
      get: getDataSource,
      add: createDataSource,
      update: updateDataSource,
    },
  };
});
